import { Route, Routes } from 'react-router-dom';

import App from './App';
import AdminMap from './Components/AdminMap/AdminMap';
import ProtectedRoute from './Components/ProtectedRoute';
import Booking from './Pages/Booking/Booking';
import Bookings from './Pages/Bookings/Bookings';
import ForgotPassword from './Pages/ForgotPassword/ForgotPassword';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import PageNotFound from './Pages/PageNotFound/PageNotFound';
import Profile from './Pages/Profile/Profile';
import User from './Pages/User/User';
import Users from './Pages/Users/Users';
import { useUserContext } from './core/context/user.context';

function AppRoutes() {
  const { user } = useUserContext();
  return (
    <Routes>
      <Route path="/" element={<App />}>
        <Route index element={<Home />} />
        <Route path="login/" element={<Login />} />
        <Route path="forgot-password/" element={<ForgotPassword />} />
        <Route element={<ProtectedRoute user={user} />}>
          <Route path="user/">
            <Route index element={<Users />} />
            <Route path=":id/" element={<User />} />
          </Route>
          <Route path="booking/">
            <Route index element={<Bookings />} />
            <Route path=":id/" element={<Booking />} />
          </Route>
          <Route path="map/" element={<AdminMap />} />
          <Route path="profile/" element={<Profile />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
